import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-block d-lg-inline-flex align-items-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "icon icon-start icon-me-2 icon-login" }
const _hoisted_5 = ["innerHTML"]


  import RegisterButton from '@/components/RegisterButton.vue';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginBox',
  props: {
    login: { type: Boolean },
    eventHolding: { type: Boolean },
    cart: { type: Object },
    getLoginBoxMessage: { type: String },
    getLoginBoxHelp: { type: String },
  },
  emits: ['openMyPageLink', 'submitForm'],
  setup(__props, { emit: __emit }) {

  const props = __props

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const emits = __emit;

  const openMyPageLink = (url: string) => {
    emits('openMyPageLink', url);
  }

  const submitForm = () => {
    emits('submitForm');
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["my-3 alert text-center fw-bold session-top-alert", __props.login ? 'alert-accent2' : 'alert-primary']),
    role: "alert"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "me-0 me-lg-4 mb-2 mb-lg-0",
        innerHTML: __props.getLoginBoxMessage
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "text-nowrap btn btn-accent2 text-decoration-none",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openMyPageLink('/mypage/')), ["stop","prevent"]))
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(__props.login ? 'マイページ' : 'ログイン'), 1)
        ]),
        _createVNode(RegisterButton, {
          onSubmitForm: submitForm,
          login: __props.login,
          eventHolding: __props.eventHolding,
          cart: __props.cart,
          registerButtonSimple: true
        }, null, 8, ["login", "eventHolding", "cart"])
      ]),
      _createElementVNode("div", {
        class: "login-box-help ms-0 ms-lg-4 mt-2 mt-lg-0",
        innerHTML: __props.getLoginBoxHelp
      }, null, 8, _hoisted_5)
    ])
  ], 2))
}
}

})